var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"idp"},[_c('img',{staticClass:"logo",attrs:{"alt":"Idp Logo","src":`${_vm.publicPath + _vm.idp.logoFilename}`}}),_c('a',{attrs:{"href":`${_vm.url}`}},[_vm._v(_vm._s(_vm.idp.displayName))]),_c('img',{staticClass:"chevron_right",attrs:{"src":require("../assets/chevron_right.svg"),"alt":"Chevron"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }